import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {
  Plus,
  ArrowRight,
  Folder,
  Settings
} from 'lucide-react'

export default function SimpleDashboard() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex items-center justify-center p-6">
      <div className="max-w-3xl w-full">
        {/* Welcome Section */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-4">
            dataraiils
          </h1>
          <p className="text-lg text-gray-500 dark:text-gray-400">
            Pharmaceutical Creative Operations
          </p>
        </div>

        {/* Main Actions */}
        <div className="space-y-3 mb-8">
          {/* Primary Action - Create Campaign */}
          <button
            onClick={() => navigate('/campaigns/new')}
            className="w-full group flex items-center justify-between p-6 bg-gray-900 dark:bg-white text-white dark:text-gray-900 rounded-xl hover:scale-[1.02] transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/10 dark:bg-gray-900/10 rounded-lg">
                <Plus className="w-6 h-6" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-lg">Create Campaign</div>
                <div className="text-sm opacity-75">Start new pharmaceutical campaign</div>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>

          {/* View Campaigns */}
          <button
            onClick={() => navigate('/campaigns')}
            className="w-full group flex items-center justify-between p-6 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200 border border-gray-200 dark:border-gray-800"
          >
            <div className="flex items-center gap-4">
              <div className="p-3 bg-gray-100 dark:bg-gray-800 rounded-lg">
                <Folder className="w-6 h-6" />
              </div>
              <div className="text-left">
                <div className="font-semibold">View Campaigns</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">Manage existing campaigns</div>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>

          {/* Settings */}
          <button
            onClick={() => navigate('/settings')}
            className="w-full group flex items-center justify-between p-6 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200 border border-gray-200 dark:border-gray-800"
          >
            <div className="flex items-center gap-4">
              <div className="p-3 bg-gray-100 dark:bg-gray-800 rounded-lg">
                <Settings className="w-6 h-6" />
              </div>
              <div className="text-left">
                <div className="font-semibold">Settings</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">Configure rules and preferences</div>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        {/* Footer Status */}
        <div className="flex items-center justify-center gap-6 text-sm text-gray-400 dark:text-gray-600 pt-8 border-t border-gray-100 dark:border-gray-900">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span>System Active</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            <span>AI Ready</span>
          </div>
        </div>
      </div>
    </div>
  )
}
